/**
 * Modals Module
 * Bootstrap modal utilities for forms
 */

export function showModal(selector: string): void {
    const modal = document.querySelector(selector);

    if (modal) {
        const bsModal = bootstrap.Modal.getOrCreateInstance(modal);
        bsModal.show();
    }
}

export function hideModal(selector: string): void {
    if (!selector) {
        return;
    }

    const modal = document.querySelector(selector);

    if (modal) {
        const bsModal = bootstrap.Modal.getInstance(modal);

        if (bsModal) {
            bsModal.hide();
        }
    }
}

export function showErrorModalWithReopen(errorModalSelector: string, formModalSelector: string): void {
    const errorModal = document.querySelector(errorModalSelector);

    if (!errorModal) {
        return;
    }

    hideModal(formModalSelector);
    const bsErrorModal = bootstrap.Modal.getOrCreateInstance(errorModal);
    bsErrorModal.show();

    if (formModalSelector) {
        const formModal = document.querySelector(formModalSelector);

        const onHide = (): void => {
            if (formModal) {
                const bsFormModal = bootstrap.Modal.getOrCreateInstance(formModal);
                bsFormModal.show();
            }
            errorModal.removeEventListener('hide.bs.modal', onHide);
        };

        const onHidden = (): void => {
            document.body.classList.add('modal-open');
            errorModal.removeEventListener('hidden.bs.modal', onHidden);
        };

        errorModal.addEventListener('hide.bs.modal', onHide);
        errorModal.addEventListener('hidden.bs.modal', onHidden);

        if (formModal) {
            const onFormHidden = (): void => {
                document.body.classList.add('modal-open');
                formModal.removeEventListener('hidden.bs.modal', onFormHidden);
            };

            formModal.addEventListener('hidden.bs.modal', onFormHidden);
        }
    }
}